import { render, staticRenderFns } from "./ItemDiscount.vue?vue&type=template&id=395a617d"
import script from "./ItemDiscount.vue?vue&type=script&lang=js"
export * from "./ItemDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports